import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './components/Home';
import Contact from './pages/Contact';
import Membership from './pages/Membership';
import Members from './pages/Members';
import Games from './pages/Games';
import Lamna from './pages/Lamna';
import About from './pages/About';
import Faq from './pages/Faq';
import DigitalGrowth from './pages/DigitalGrowth';
import Testimonials from './pages/Testimonials';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Resources from './pages/Resources';
import Transparency from './pages/Transparency';
import Credits from './pages/Credits';
import Programs from './pages/Programs';
import Labs from './pages/Labs';
import HardwareAssistance from './pages/HardwareAssistance';
import VirtualHouseCall from './pages/VirtualHouseCall';
import StaffWorkspace from './pages/StaffWorkspace';
import ScamCheckLanding from './pages/ScamCheckLanding';
import ScamCheck from './pages/ScamCheck';
import DeviceLocker from './pages/DeviceLocker';
import LearningCenter from './pages/LearningCenter';
import Network from './pages/Network';
//import DemoProduct from './pages/DemoProduct';

import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("ZelT | IT Services");

  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/members" element={<Members />} />
            <Route path="/games" element={<Games />} />
            <Route path="/it" element={<Lamna />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/digital-growth" element={<DigitalGrowth />} />
            <Route path="/transparency" element={<Transparency />} />
            <Route path="/credits" element={<Credits />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/labs" element={<Labs />} />
            <Route path="/hardware-assistance" element={<HardwareAssistance />} />
            <Route path="/remote" element={<VirtualHouseCall />} />
            <Route path="/staff" element={<StaffWorkspace />} />
            <Route path="/scam-check" element={<ScamCheckLanding />} />
            <Route path="/scam-check/analyze" element={<ScamCheck />} />
            <Route path="/devices" element={<DeviceLocker />} />
            <Route path="/learn" element={<LearningCenter />} />
            <Route path="/network" element={<Network />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}


export default App;
